import { useState } from "react";
import { Icons } from "../../components/common/Icons";
import api from "../../services/api";
import T from '../../assets/styles/theme';import "../../assets/styles/Employee/EmpSettingsPage.css";

function EmpSettingsPage() {
  const [current, setCurrent] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const handleSubmit = async () => {
    setMsg("");setErr("");
    if (!current || !newPw || !confirm) {setErr("All fields are required.");return;}
    if (newPw.length < 4) {setErr("New password must be at least 4 characters.");return;}
    if (newPw !== confirm) {setErr("Passwords do not match.");return;}
    setLoading(true);
    try {
      await api.changePassword(current, newPw);
      setMsg("Password changed successfully!");
      setCurrent("");setNewPw("");setConfirm("");
    } catch (e) {
      setErr(e.message || "Failed to change password.");
    } finally {setLoading(false);}
  };

  return (
    <div className="card animate-in empsettingspage-inline-1">
      <div className="card-header"><div className="card-title">Change Password</div></div>
      <div className="card-body">
        {msg && <div style={{ "--empsettingspage-1-background": T.successBg, "--empsettingspage-1-color": T.success }} className="empsettingspage-dyn-1">✓ {msg}</div>}
        {err && <div style={{ "--empsettingspage-2-background": T.dangerBg, "--empsettingspage-2-color": T.dangerDark }} className="empsettingspage-dyn-2">⚠ {err}</div>}
        <div className="form-group"><label className="form-label">Current Password</label><input type="password" className="form-input" placeholder="••••••••" value={current} onChange={(e) => {setCurrent(e.target.value);setErr("");}} /></div>
        <div className="form-group"><label className="form-label">New Password</label><input type="password" className="form-input" placeholder="••••••••" value={newPw} onChange={(e) => {setNewPw(e.target.value);setErr("");}} /></div>
        <div className="form-group"><label className="form-label">Confirm New Password</label><input type="password" className="form-input" placeholder="••••••••" value={confirm} onChange={(e) => {setConfirm(e.target.value);setErr("");}} /></div>
        <div className="form-actions"><button className="btn-submit" onClick={handleSubmit} disabled={loading}>{loading ? "Updating..." : "Update Password"}</button></div>
      </div>
    </div>);

}

export default EmpSettingsPage;